import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import Seo from '../../components/Seo/Seo';
import { SITE } from '../../config/site';
import { LEGAL, LEGAL_PAGES, LEGAL_UPDATED } from './legalContent';
import styles from './Legal.module.css';

/**
 * One layout for the three legal pages: /privacy, /terms, /data-deletion
 *   <Legal doc="privacy" />
 */
export default function Legal({ doc }) {
    const page = LEGAL[doc];
    if (!page) return null;

    return (
        <section className={styles.page}>
            <Seo title={page.title} description={page.description} />

            <div className={styles.inner}>
                <nav className={styles.tabs} aria-label="Legal pages">
                    {LEGAL_PAGES.map((p) => (
                        <NavLink key={p.path} to={p.path} className={({ isActive }) => `${styles.tab} ${isActive ? styles.tabActive : ''}`}>
                            {p.label}
                        </NavLink>
                    ))}
                </nav>

                <div className={styles.grid}>
                    <nav className={styles.toc} aria-label="On this page">
                        <p>On this page</p>
                        <ol>
                            {page.sections.map((s, i) => (
                                <li key={s.title}><Link to={{ hash: `#s${i + 1}` }}>{s.title}</Link></li>
                            ))}
                        </ol>
                    </nav>

                    <article className={styles.doc}>
                        <h1>{page.title}</h1>
                        <p className={styles.updated}>Last updated {LEGAL_UPDATED}</p>

                        <div className={styles.short}>
                            <h2>The short version</h2>
                            <ul>{page.summary.map((line, i) => <li key={i}>{line}</li>)}</ul>
                        </div>

                        {page.sections.map((s, i) => (
                            <section key={s.title} id={`s${i + 1}`} className={styles.section} aria-labelledby={`h${i + 1}`}>
                                <h2 id={`h${i + 1}`}><span className={styles.num}>{i + 1}.</span>{s.title}</h2>
                                {s.body}
                            </section>
                        ))}

                        <p className={styles.contact}>
                            <strong>Questions?</strong> Write to <a href={`mailto:${SITE.email}`}>{SITE.email}</a>. We reply within 7 working days.
                        </p>
                    </article>
                </div>
            </div>
        </section>
    );
}
